// @flow

import type { Action } from "redux-action";
import type { AppAdoptionState } from "./types";
import { downloadCsvFile } from "@sagas/utils";

export const onGetAppAdoptionHighlights = (state: AppAdoptionState) => ({ payload }: Object) => ({
  ...state,
  highlights: {
    ...state.highlights,
    isLoading: true,
    error: false,
  },
});

export const onGetAppAdoptionHighlightsSuccess = (state: AppAdoptionState) => ({
  payload,
}: Object) => ({
  ...state,
  highlights: {
    isLoading: false,
    error: false,
    onboardedToApp: payload.onboardedToApp,
    downloads: payload.downloads,
  },
});
export const onGetAppAdoptionHighlightsError = (state: AppAdoptionState) => ({
  payload,
}: Object) => ({
  ...state,
  highlights: {
    isLoading: false,
    error: payload,
    onboardedToApp: null,
    downloads: null,
  },
});
export const onGetAppAdoptionDepartments = (state: AppAdoptionState) => ({ payload }: Object) => ({
  ...state,
  departments: {
    ...state.departments,
    isLoading: true,
    error: false,
  },
});

export const onGetAppAdoptionDepartmentsSuccess = (state: AppAdoptionState) => ({
  payload,
}: Object) => ({
  ...state,
  departments: {
    isLoading: false,
    error: false,
    data: payload,
  },
});
export const onGetAppAdoptionDepartmentsError = (state: AppAdoptionState) => ({
  payload,
}: Object) => ({
  ...state,
  departments: {
    isLoading: false,
    error: payload,
    data: null,
  },
});

export const onExportAppAdoptionDepartments = (state: AppAdoptionState) => ({
  payload,
}: Object) => ({
  ...state,
  departments: {
    ...state.departments,
    isLoading: true,
  },
});

export const onExportAppAdoptionDepartmentsSuccess = (state: AppAdoptionState) => ({
  payload,
}: Object) => {
  downloadCsvFile(payload, "App Adoption Results.csv");
  return {
    ...state,
    departments: {
      ...state.departments,
      isLoading: false,
    },
  };
};
export const onExportAppAdoptionDepartmentsError = (state: AppAdoptionState) => ({
  payload,
}: Object) => ({
  ...state,
  departments: {
    ...state.departments,
    isLoading: false,
    error: payload,
  },
});
